module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_VCNC_m.382a2659b165f06504768287ea89ae82.png";